import { create } from "zustand";

type FormErrors = Record<string, string | undefined>;

export interface FormValues {
	firstName: string;
	lastName: string;
	email: string;
	state: string;
	loanAmount: string;
	phone: string;
	loanPurpose: string;
	loanType: string;
	assetAge: string;
	propertyBacked: string;
	abnAge: string;
	monthlyTurnover: string;
	// Business Loan
	businessabnAge: string;
	businessName: string;
	financeReason: string;
	ownershipTime: string;
	abnTime: string;
}

export const initialFormValues: FormValues = {
	firstName: "",
	lastName: "",
	email: "",
	state: "",
	loanAmount: "",
	phone: "",
	loanPurpose: "",
	loanType: "",
	assetAge: "",
	propertyBacked: "",
	abnAge: "",
	monthlyTurnover: "",
	// Business Loan
	businessabnAge: "",
	businessName: "",
	financeReason: "",
	ownershipTime: "",
	abnTime: "",
};

export interface FormData {
	formValues: FormValues;
	formErrors: FormErrors;
	// Initializes formValues
	resetFormValues: () => void;
	// Setter function to update specific fields
	setFormValue: (field: keyof FormValues, value: string) => void;
	setFormError: (field: string, message: string) => void;
	clearFormError: (field: string) => void;
}

export const useFormData = () =>
	create<FormData>((set) => ({
		formValues: { ...initialFormValues },
		formErrors: {},

		resetFormValues: () =>
			set(() => ({
				formValues: { ...initialFormValues },
				formErrors: {},
			})),

		// Dynamic setter function to update form fields
		setFormValue: (field, value) =>
			set((state) => ({
				formValues: {
					...state.formValues,
					[field]: value,
				},
				formErrors: {
					...state.formErrors,
					[field]: undefined,
				},
			})),

		setFormError: (field, message) =>
			set((state) => ({
				formErrors: {
					...state.formErrors,
					[field]: message,
				},
			})),

		clearFormError: (field) =>
			set((state) => ({
				formErrors: {
					...state.formErrors,
					[field]: undefined,
				},
			})),
	}));
